"use client";

import React from "react";
import {PageCompetitionBookTySchema} from "@/sanity/pages/PageCompetitionBookTyTemplate";

import Image from "next/image";
import Chip from "@/components/global/ui/Chip";
import DividerGreenLine from "@/components/global/ui/DividerGreenLine";
import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {richTextComponent} from "@/sanity/sanityPortableText";

import logo from "@/public/global/new-logo-full-light.svg";

export default function HeroSection({
  data,
  className
}: {
  data: PageCompetitionBookTySchema;
  className?: string;
}) {
  return (
    <section className={cn(
      "relative overflow-clip pt-[1rem] pb-[12rem] lg:pb-[22rem]",
      className
    )}>
      <div className="container flex flex-col items-center">
        <Image
          className="!w-[16rem] mb-[5rem] lg:mb-[16rem]"
          src={logo}
          alt="bitbull logo"
        />

        <Chip
          className="prose-img:!w-[3rem]"
          image={data?.heroChip?.icon}
          text={data?.heroChip?.text}
        />

        <div className="richtext">
          <h1 className="!font-ivy !text-[7rem] sm:!text-[8rem] lg:!text-[12rem] leading-none italic gradient-title-white sm:w-[60rem] lg:w-[min(100rem,100%)] tracking-normal pb-[4rem]">{data?.heroTitle}</h1>
        </div>

        <DividerGreenLine
          className="w-[min(89.5rem,100%)] mb-[4rem]"
        />

        {data?.heroText && (
          <div className="richtext w-[min(94rem,100%)] prose-p:text-white/60 prose-p:font-light">
            <PortableText
              value={data.heroText}
              components={richTextComponent}
            />
          </div>
        )}
      </div>
    </section>
  );
}
